import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { useState } from "react"
import type { ITrainingModule } from "types/trainingModuleTypes"
import { DeleteTrainingModuleDialog } from "./DeleteTrainingModuleDialog"
import { UpdateTrainingModuleDialog } from "./UpdateTrainingModuleDialog"

type Props = {
  trainingModule: ITrainingModule
}

export function TrainingModuleCardMenu({ trainingModule }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)

  const handleClickMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleClickMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
  }

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleClickMenuOpen}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClickMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <UpdateTrainingModuleDialog trainingModule={trainingModule} />
        <DeleteTrainingModuleDialog trainingModule={trainingModule} />
      </Menu>
    </>
  )
}
